import gqlRequest from 'graphql/generic';
import { Notifications } from '../types';

const queryUpdateNotification = `
  mutation UpdateNotification($id: ID!, $subject: String, $html: String) {
    updateNotification(_id: $id, subject: $subject, html: $html) {
      _id
      subject
      html
      prompt
    }
  }
`;

type UpdateNotificationParams = Omit<Notifications, '_id'> & {
  id: string;
};

type UpdateNotificationReturn = {
  updateNotification: Notifications;
};

export const updateNotification = (params: UpdateNotificationParams) =>
  gqlRequest<UpdateNotificationReturn, UpdateNotificationParams>(queryUpdateNotification, params);

const queryDeleteNotification = `
  mutation DeleteNotification($id: ID!) {
    deleteNotification(_id: $id) {
      _id
    }
  }
`;

type DeleteNotificationParams = {
  id: string;
};

type DeleteNotificationReturn = {
  deleteNotification: {
    _id: string;
  };
};

export const deleteNotification = (params: DeleteNotificationParams) =>
  gqlRequest<DeleteNotificationReturn, DeleteNotificationParams>(queryDeleteNotification, params);

const queryCreateNotification = `
  mutation CreateNotification($subject: String!, $html: String!) {
    createNotification(subject: $subject, html: $html) {
      _id
      subject
      html
      prompt
    }
  }
`;

type CreateNotificationParams = Omit<Notifications, '_id'>;

type CreateNotificationReturn = {
  createNotification: Notifications;
};

export const createNotification = (params: CreateNotificationParams) =>
  gqlRequest<CreateNotificationReturn, CreateNotificationParams>(queryCreateNotification, params);
